import { PumpOutlined } from "@gds-react/icons";
import useCoreContext from "@gf-core/widgets/hooks/useCoreContext";
import SVGImage from "../../components/SVGImage";
import { DeviceBase } from "../../generated-api/device";

export const GetIconByDeviceType = (
  type: DeviceBase["$deviceType"],
  displayFamilyName: string,
  size = 18,
  color?: string,
) => {
  const { theme, themeConfig } = useCoreContext();
  const svgSize = size < 0 ? 18 : size;

  if (type === "GdpCommunicationDevice") {
    return (
      <SVGImage
        icon="CloudGatewaySVG"
        style={{
          width: svgSize,
          height: svgSize,
          filter:
            (color ?? themeConfig.appearance === "dark")
              ? "invert(1)"
              : "invert(0)",
        }}
      />
    );
  } else if (type === "IoTerminal" || type === "ModbusRtu") {
    return (
      <SVGImage
        icon="SensorOutlinedSvg"
        style={{
          width: svgSize,
          height: svgSize,
          filter:
            (color ?? themeConfig.appearance === "dark")
              ? "invert(1)"
              : "invert(0)",
        }}
      />
    );
  } else if (
    type === "GeniProDevice" &&
    displayFamilyName === "Pump Control Unit"
  ) {
    return (
      <SVGImage
        icon="controller_outline"
        style={{
          width: svgSize - 2,
          height: svgSize - 2,
          filter:
            (color ?? themeConfig.appearance === "dark")
              ? "invert(1)"
              : "invert(0)",
        }}
      />
    );
  } else if (
    type === "VirtualDevice" &&
    displayFamilyName === "Edge Application"
  ) {
    return (
      <SVGImage
        icon="software_outline"
        style={{
          width: svgSize,
          height: svgSize,
          filter:
            (color ?? themeConfig.appearance === "dark")
              ? "invert(1)"
              : "invert(0)",
        }}
      />
    );
  } else {
    return (
      <PumpOutlined
        style={{
          width: svgSize,
          height: svgSize,
          color: color ?? theme.core.colors.text.primary.color,
        }}
      />
    );
  }
};
